import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.finally.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    formId: {
      type: Number,
      required: true
    },
    inline: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      form: {},
      formFields: [],
      loading: false,
      requiredCheckboxes: [],
      originalFields: []
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$_this$$axios$g, data, template, splitIndex;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$axios.get("/forms/".concat(_this.formId));

            case 2:
              _yield$_this$$axios$g = _context.sent;
              data = _yield$_this$$axios$g.data;
              template = data.data;
              template.fields.forEach(function (field) {
                if (field.type === 'checkbox') {
                  _this.form[field.name] = [];

                  if (field.required) {
                    _this.requiredCheckboxes.push(field.name);
                  }
                } else {
                  _this.form[field.name] = null;
                }
              });
              splitIndex = Math.ceil(template.fields.length / 2);
              _this.formFields = [template.fields.slice(0, splitIndex), template.fields.slice(splitIndex)];
              _this.originalFields = template.fields;

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    validationRulesForField: function validationRulesForField(field) {
      var rules = field.rules || '';

      if (field.required) {
        if (field.rules) {
          rules += '|';
        }

        rules += 'required';
      }

      return rules;
    },
    submit: function submit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                _context2.prev = 1;
                Object.keys(_this2.form).forEach(function (name) {
                  if (_this2.requiredCheckboxes.includes(name)) {
                    _this2.form[name] = [_this2.form[name]];
                  }
                });
                _context2.next = 5;
                return _this2.$axios.post('/forms/' + _this2.formId, _this2.form);

              case 5:
                _this2.$formulate.reset("dynamic-form-".concat(_this2.formId));

                if (_this2.$listeners['event:success']) {
                  _this2.$emit('event:success');
                } else {
                  _this2.$toast.success(_this2.$t('Form has been submitted.'));
                }

                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](1);

                if (_this2.$listeners['event:error']) {
                  _this2.$emit('event:error');
                } else {
                  _this2.$toast.error(_this2.$t('Something went wrong while submitting the form. Try again later.'));
                }

              case 12:
                _this2.loading = false;

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 9]]);
      }))();
    }
  }
};